import { pushCellHistory } from "./pushCellHistory";
import { State } from "./types";

export interface ChangeCurrentCellTypeAction {
  label: string;
  type: "CHANGE CURRENT CELL TYPE";
}

export const changeCurrenCellType = (
  state: State,
  action: ChangeCurrentCellTypeAction,
): State => {

  let newCells = state.cells.map(cell => {
    if (cell.selected) {
      return {
        ...cell,
        cellType:action.label
      }
    }
    return cell;
  })
  return pushCellHistory(state, newCells);
};
